import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import colors from "assets/theme/base/colors"

const BAR_COLOR = {
  ERROR: colors.error.main,
  WARNING: colors.warning.main,
  INFO: colors.grey[500],
}
const LABEL_WIDTH = "30%"

const AmountCompareChart = ({ compare }) => {
  const { ticks, lines } = compare
  return (
    <MDBox mt={1.5}>
      <MDTypography variant="caption" fontWeight="bold" display="block" mb={0.5}>
        Amount ranges
      </MDTypography>
      {/* Ticks stay readable on a phone by scrolling here, not the whole page. */}
      <MDBox sx={{ overflowX: "auto" }}>
        <MDBox sx={{ minWidth: `calc(${LABEL_WIDTH} + ${ticks.length * 3.5}rem)` }}>
          {lines.map((line) => (
            <MDBox key={line.key} display="flex" alignItems="center" gap={1} mb={0.5}>
              <MDTypography
                variant="caption"
                color="text"
                fontWeight={line.severity ? "regular" : "bold"}
                sx={{ flex: `0 0 ${LABEL_WIDTH}`, minWidth: 0, wordBreak: "break-word" }}
              >
                {line.label}
              </MDTypography>
              <MDBox position="relative" height="1rem" bgColor="grey-100" sx={{ flex: 1 }}>
                {ticks.map((t) => (
                  <MDBox
                    key={t.label}
                    sx={{
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      left: `${t.position}%`,
                      width: "1px",
                      backgroundColor: colors.grey[300],
                    }}
                  />
                ))}
                {line.bar ? (
                  <MDBox
                    borderRadius="sm"
                    sx={{
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      left: `${line.bar.left}%`,
                      width: `${line.bar.right - line.bar.left}%`,
                      // A single amount has no width, but still has to be visible.
                      minWidth: "0.375rem",
                      backgroundColor: BAR_COLOR[line.severity] || colors.info.main,
                    }}
                  />
                ) : (
                  <MDTypography variant="caption" color="text" sx={{ position: "absolute", left: 4 }}>
                    Not one continuous range
                  </MDTypography>
                )}
              </MDBox>
            </MDBox>
          ))}
          <MDBox display="flex" gap={1}>
            <MDBox sx={{ flex: `0 0 ${LABEL_WIDTH}` }} />
            <MDBox position="relative" height="1.25rem" sx={{ flex: 1 }}>
              {ticks.map((t, idx) => {
                let transform = "translateX(-50%)"
                if (idx === 0) transform = "none"
                if (idx === ticks.length - 1) transform = "translateX(-100%)"
                return (
                  <MDTypography
                    key={t.label}
                    variant="caption"
                    color="text"
                    sx={{ position: "absolute", left: `${t.position}%`, transform, whiteSpace: "nowrap" }}
                  >
                    {t.label}
                  </MDTypography>
                )
              })}
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  )
}

export default AmountCompareChart
